// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"styles_outerContainer__N74sS","innerContainer":"styles_innerContainer__unBIe","animation":"styles_animation__8dH5P"};